/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import React from 'react';
import ButtonLinkItem from './ButtonLinkItem';
import MailIcon from '../icons/MailIcon';
import { Download, FileText } from 'lucide-react';
import { cn } from '@/lib/utils';

const iconMap: Record<string, any> = {
  Download: Download,
  FileText: FileText,
  Mail: MailIcon,
};

export default function ButtonLinkItemList({
  profile,
  justify = 'start',
  showOnlyContact = false,
}: {
  profile: any;
  justify?: 'start' | 'center' | 'end';
  showOnlyContact?: boolean;
}) {
  if (!profile) return null;

  const justifyClasses = {
    start: 'justify-center lg:justify-start',
    center: 'justify-center',
    end: 'justify-center lg:justify-end',
  };

  return (
    <div
      className={cn(
        'flex flex-col sm:flex-row sm:flex-wrap items-stretch sm:items-center gap-3 sm:gap-4 w-full',
        justifyClasses[justify],
      )}
    >
      {/* Required: Get in Touch Button */}
      {profile.getInTouchUrl && profile.getInTouchUrl !== '#' && (
        <div className="flex flex-col gap-2 w-full sm:w-auto">
          <ButtonLinkItem
            linkDestination={profile.getInTouchUrl}
            linkIcon={<MailIcon />}
            linkText="Get in Touch"
            openInNewTab
            variant="primary"
          />
        </div>
      )}

      {/* Optional Buttons (Dynamic) */}
      {!showOnlyContact &&
        profile.buttons?.map((button: any) => (
          <div key={button.id} className="flex flex-col gap-2 w-full sm:w-auto">
            <ButtonLinkItem
              linkDestination={button.url}
              linkIcon={
                button.icon && iconMap[button.icon] ? (
                  React.createElement(iconMap[button.icon], {
                    size: 18,
                    className: 'text-primary',
                  })
                ) : (
                  <Download size={18} className="text-primary" />
                )
              }
              linkText={button.label}
              variant={button.variant as 'primary' | 'secondary'}
              openInNewTab
              isDownload={button.icon === 'Download'}
              downloadName={button.fileName}
            />
          </div>
        ))}
    </div>
  );
}
